import React from 'react'; // eslint-disable-line

import t from '../../../theme/admin/adminStyles';

/** @jsxImportSource @emotion/react */

export const AdminDatePicker = (props: {
  defaultValue?: string;
  min?: string;
  max?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  return (
    <input
      type="date"
      defaultValue={props.defaultValue}
      min={props.min}
      max={props.max}
      onChange={props.onChange}
      css={[t.px_3, t.py_2, t.border_solid, t.border, t.border_dark_1, t.text_sm]}
    />
  );
};
